import {
  SET_TABS,
  SET_ACTIVE_TAB,
  SET_LOADED_TAB,
  SET_SORTS,
  SET_LOAD_MORE,
  SET_SEARCH_TYPE,
  SET_SEARCH_TERM,
  SET_POPSTATE,
  SET_FILTERS,
  APPLY_FILTER,
  APPLY_SORT,
  CLEAR_FILTERS,
  SET_FIRST_QUERY,
} from '@/context/search/types';

export const setTabs = payload => ({
  type: SET_TABS,
  payload,
});

export const setActiveTab = payload => ({
  type: SET_ACTIVE_TAB,
  payload,
});

export const setLoadedTab = payload => ({
  type: SET_LOADED_TAB,
  payload,
});

export const setSorts = payload => ({
  type: SET_SORTS,
  payload,
});

export const setLoadMore = payload => ({
  type: SET_LOAD_MORE,
  payload,
});

export const setSearchType = payload => ({
  type: SET_SEARCH_TYPE,
  payload,
});

export const setSearchTerm = payload => ({
  type: SET_SEARCH_TERM,
  payload,
});

export const setPopstate = payload => ({
  type: SET_POPSTATE,
  payload,
});

export const setFilters = payload => ({
  type: SET_FILTERS,
  payload,
});

export const applyFilter = payload => ({
  type: APPLY_FILTER,
  payload,
});

export const applySort = payload => ({
  type: APPLY_SORT,
  payload,
});

export const clearFilters = payload => ({
  type: CLEAR_FILTERS,
  payload,
});

export const setFirstQuery = payload => ({
  type: SET_FIRST_QUERY,
  payload,
});
